module.exports = {
  wait: 'Please wait...',
  login: 'Login',
  current_password: 'Current Password',
  password: 'Password',
  select_product: 'Select Product',
  enter_code: 'Enter the SMS verification code',
  phone: 'Phone Number',
  phone_required: 'Phone number is a required field',
  email_required: 'Email is a required field',
  email: 'Email',
  role_required: 'Please select at least 1 role',
  name_required: 'Name is a required field',
  adduser: 'Add User',
  updateuser: 'Update User',
  clear: 'clear',
  roles: 'Roles',
  accountStatus: 'Account Status',
  user_email: 'User Email',
  user_name: 'User Name',
  placeholderemail: 'Please enter user email',
  placeholdername: 'Enter user name',
  placeholderrole: 'Please enter roles to add or update',
  phone_number: 'Phone Number',
  clientUserId: 'Client User ID',
  subscriptionExpiresAt: 'Expires At',
  product: 'Product',
  subscriber_added: 'Subscriber added',
  price: 'Price',
  retry_webhook: 'Are you sure you want to retry this webhook?',
  confirm: 'Confirm',
  webhook_logs: 'Webhooks',
  new_price: 'New Price',
  product_required: 'Product is a required field',
  payment_type_required: 'Payment type is a required field',
  verif_code: 'SMS verification code',
  order_confirmed: 'Order Confirmed',
  continue: 'Continue',
  cancel: 'Cancel',
  back: 'Back',
  delete: 'Are you sure you want to delete?',
  deleteAdmin: 'This account cant be deleted as it is used by Zlick Support team. If you still believe this account should be deleted, please contact us via support@zlick.it',
  start_order: 'Start New Order',
  p_c_sms: 'Purchase confirmation SMS',
  close: 'Close',
  order_info: 'Order Info',
  pin_required: 'PIN is required',
  pin_length: 'The PIN must be {length} characters long',
  wrong_pin: 'Wrong PIN. Please try again!',
  max_pin_attempts: 'Verified code 3 times, no more attempts. Please send a new SMS',
  something_went_wrong: 'Something went wrong. Please try again',
  send_sms: 'Send SMS',
  refundNotAllowed: 'Refunds not allowed',
  refundTooOld: 'Refund could not be processed, transaction is older than 185 days. Please contact Zlick Team to process manually.',
  alreadyRefunded: 'Already refunded',
  refundFailed: 'Refund failed',
  manualRefund: 'Manual return process',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  referenceNumber: 'Reference Number',
  transactionId: 'Transaction Id',
  productName: 'Product Name',
  transactionType: 'Transaction Type',
  period: 'Period',
  amount: 'Amount',
  additionalFee: 'Additional Fee',
  chargedAmount: 'Charged Amount',
  user: 'User',
  refundReason: 'Refund / Explanation',
  reload: 'Reload',
  retry: 'Retry',
  transactions: 'Transactions',
  orders: 'Orders',
  telemarketing: 'Telemarketing',
  addsubscriber: 'Add Subscriber',
  searchPlaceholder: 'Enter search query',
  password_required: 'Password is required',
  password_requirements: 'Password must be at least {length} characters long, contain uppercase and lowercase letters and at least {numbers}',
  something_required: '{something} is required',
  something_not_valid: '{something} is not valid',
  temp_password_label: 'Currently valid temporary password',
  new_password: 'New Password',
  confirm_password: 'Repeat new password',
  password_not_match: 'Passwords do not match',
  firstName: 'First name',
  lastName: 'Last Name',
  completeRegistration: 'Complete Registration',
  submit: 'SUBMIT',
  expiryDate: 'Expiry Date',
  paymentType: 'Payment Type',
  carrier: 'Telecom / Carrier',
  name: 'Explanation',
  transaction_id: 'Transaction ID',
  addSubHead: 'Add Subscriber',
  telemarketingHead: 'Telemarketing',
  ordersHead: 'Orders',
  trxHead: 'Transactions',
  webhooksHead: 'Webhooks',
  changePasswordHead: 'Change Password',
  cancelOrderDialog: 'Are you sure you want to unsubscribe?',
  unsubscribe: 'Unsubscribe',
  refundReason_required: 'Refund reason is required',
  reset: 'Reset',
  noStatus: 'No status',
  oneOffPayment: 'One - off payment',
  ok: 'OK',
  transactionsHistory: 'Transactions history',
  refundDialogInfo: 'Please let us know why You are making this refund:',
  refund: 'Refund',
  noResponseFromWebhook: 'No Response received from the webhook, try retrying the webhook.',
  urlWebHook: 'URL',
  eventId: 'Event Id',
  status: 'Status',
  request: 'Request',
  responses: 'Responses',
  requestBody: 'Request Body',
  responseBody: 'Response Body',
  retryAttempts: 'Retry Attempts',
  pincodePlaceholder: 'Enter pin Code sent on your email',
  confirmPinCode: 'confirm PinCode',
  backToLogin: 'Back To Login',
  toolTipTwoFA: 'Enabling or disabling this option will control the Two-Factor Authentication for all users in the group. Upon enabling, a pin code will be sent to each user\'s registered email address to facilitate the authentication process',
  pincode_required: 'PinCode is a required field',
  pincode_must_be_number: 'Pincode must be a number',
  reports: 'Reports'
}



// WEBPACK FOOTER //
// ./src/i18n/strings.en.js